import SearchIcon from '@mui/icons-material/Search';
import { forwardRef } from 'react';

import type { TextInputProps } from './TextInput';
import { TextInput } from './TextInput';

export interface SearchInputProps extends Omit<TextInputProps, 'type' | 'startAdornment' | 'multiline'> {
  onSearch?: (value: string) => void;
}

export const SearchInput = forwardRef<HTMLDivElement, SearchInputProps>(function SearchInput({ onSearch, clearable = true, onKeyDown, ...rest }, ref) {
  return (
    <TextInput
      ref={ref}
      type="search"
      clearable={clearable}
      startAdornment={<SearchIcon fontSize="small" />}
      onKeyDown={(event) => {
        onKeyDown?.(event);
        if (event.key === 'Enter' && !event.defaultPrevented) onSearch?.((event.target as HTMLInputElement).value);
      }}
      {...rest}
    />
  );
});
